import act from './act';
export default {
  modelName: 'audit_question_template',
  modelVersionName: 'audit_question_template_version',
  label: '稽核新增章節題目',
  fields: {
    last_version: {
      type: 'last_version',
      fields: {
        locales: {
          type: 'locales',
          displayLabel: false,
          fields: {
            title: {
              type: 'text',
              label: '題目標題',
              autofocus: true,
              rules: 'required',
              maxlength: 200,
            },
            remark: {
              type: 'textarea',
              label: '查核提示',
              maxlength: 5000,
              placeholder: '請輸入查核提示',
            },
          },
        },
        attaches: {
          type: 'files',
          label: '查核提示附件',
          uploadUrl: '/audit_question_template_version/attach/',
        },
        acts: {
          label: '相關法規',
          type: 'act-picker',
          modelName: 'act',
          textKey: 'name',
          rules: 'required',
          fields: act.fields,
          noReset: true,
          requiredField: 'areas',
          hasCloseChips: true,
          conditionKeys: [
            {
              fieldName: 'areas',
              type: 'array',
              conditionName: 'areas',
            },
          ],
          getText: (item) => {
            if (!item.last_version) {
              return null;
            } else {
              return `${item.last_version.name}`;
            }
          },
          sm: 6,
        },

        effects: {
          label: '風險燈號',
          type: 'hasMany',
          modelName: 'effect',
          textKey: 'name',
          sm: 6,
          conditionKeys: [
            {
              fieldName: 'areas',
              conditionName: 'areas',
              type: "array",
            },
          ],
        },
      },
    },
  },
  fieldsRead: [
    'last_version.locales',
    'last_version.attaches',
    'last_version.articles',
    'last_version.effects',
    'last_version.acts',
  ],
};
